type MaybeAsyncOption<T> =
    | T
    | undefined
    | PromiseLike<T | undefined>
    | (() => T | undefined | PromiseLike<T | undefined>);

export type HeadersOptions = {
    aquireBearerToken?: MaybeAsyncOption<string | null>;
    additionalHeaders?: MaybeAsyncOption<Record<string, string>>;
};

async function resolveOption<T>(
    option: MaybeAsyncOption<T>
): Promise<T | undefined> {
    option = await option;
    if (typeof option === 'function') {
        option = (option as any)();
    }
    return option as T | undefined;
}

export async function getHeaders(
    options: HeadersOptions | null | undefined
): Promise<Record<string, string>> {
    options ??= {};

    const [accessToken, additionalHeaders] = await Promise.all([
        resolveOption(options.aquireBearerToken),
        resolveOption(options.additionalHeaders),
    ]);

    const headers: Record<string, string> = {};

    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return { ...headers, ...additionalHeaders };
}

export function getHeadersProvider(
    options?: HeadersOptions | null | undefined
): () => Promise<Record<string, string>> {
    return () => getHeaders(options);
}
